export enum SUPPORTED_LANGUAGES {
    // Syonet CRM
    'PT-BR' = 'pt_BR',
    'EN-US' = 'en_US',
    'ES' = 'es',
    'ES-PY' = 'es_PY',
    'ES-PER' = 'es_PE',
    // Campos Dealer
    'es-BO' = 'es_BO',
    'pt-BR' = 'pt_BR',
    'en-US' = 'en_US',
    'es-PY' = 'es_PY'
}

export type Language = keyof typeof SUPPORTED_LANGUAGES

export type LanguageValue = typeof SUPPORTED_LANGUAGES[keyof typeof SUPPORTED_LANGUAGES]
